<template>
  <PublicView>
    <div id="search-page" class="pt-3">
      <div class="container-fluid">
        <div class="row">
            
          <div class="col-12">
            <h1>Tìm kiếm</h1>
        </div>
          <div class="col-12">
            <div
              class="product-wrapper product_carousel splide is-overflow is-initialized splide--grid splide--slide splide--ltr splide--draggable is-active"
              id="splide01" role="region" aria-roledescription="carousel">
              <div class="splide__track splide__track--slide splide__track--ltr splide__track--draggable"
                id="splide01-track" aria-live="polite" aria-atomic="true">
                <div class="splide__list" id="splide01-list" role="presentation">
                  <ProductItem v-for="p in products" :id="p._id" :key="p._id" />
                </div>
              </div>
            </div>

          </div>
          
          <div class="col-12">

            <div class="pagination" style="margin-top: 20px; text-align: center;">
              <button class="btn btn-light" v-if="currentPage > 2" @click="goToPage(1)"><i
                  class="fas fa-chevron-double-left"></i></button>
              <button class="btn btn-light" v-if="currentPage > 1" @click="goToPage(currentPage - 1)"><i
                  class="fas fa-angle-left"></i></button>
              <button class="btn btn-light">Trang {{ currentPage }} / {{ totalPages }}</button>
              <button class="btn btn-light" v-if="currentPage < totalPages" @click="goToPage(currentPage + 1)"><i
                  class="fas fa-angle-right"></i></button>
              <button class="btn btn-light" v-if="currentPage < totalPages - 1" @click="goToPage(totalPages)"><i
                  class="fas fa-chevron-double-right"></i></button>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
  </PublicView>
</template>
<script>

const axios = require("axios").default;
import PublicView from "@/components/PublicView.vue";
import ProductItem from "@/components/Home/ProductItem.vue";
export default {
  name: "DanhMucView",
  data() {
    return {
      products: [],
      totalItems: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.getAllProducts(this.query);
  },
  computed: {
    query() {
      return this.$route.query.q;
    },
    totalPages() {
      return Math.ceil(this.totalItems / 28);
    }
  },
  watch: {
    query(val) {
    this.getAllProducts(val);

    }
  },
  methods: {
    goToPage(page) {
      this.currentPage = page;
      this.getAllProducts(this.query);
    },
    async getAllProducts(query) {
      let data = await axios.get(`/api/search?q=${encodeURIComponent(query)}&page=${this.currentPage}`);
      if (data && data.data) {
        this.products = data.data.products;
        if (this.products.length == 1 && data.data.total == 1) {
            this.$router.push({ path: "/san-pham/" + this.products[0].alias + "/" + this.products[0].code });
        }
        this.totalItems = data.data.total;
      }
    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      // Some system encode vietnamese combining accent as individual utf-8 characters
      // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      // Bỏ các khoảng trắng liền nhau
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      // Bỏ dấu câu, kí tự đặc biệt
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    cateLink(cateObj) {
      return "/danh-muc/" + this.removeVietnameseTones(cateObj.name).replaceAll(" ", "-").toLowerCase() + "/" + cateObj._id;
    },
    price(price) {
      const config = {
        style: 'currency',
        currency: 'VND',
        maximumFractionDigits: 9
      };
      return new Intl.NumberFormat('vi-VN', config).format(price);
    },
  },

  components: {
    PublicView,
    ProductItem
  }
};
</script>
<style lang="less">
.breadcrumb {
  border: 0;
  background-color: transparent;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 25px 20px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 0 0 60px 0;

  >li.breadcrumb-item {
    padding: 0 10px 0 0;
    white-space: inherit;
    word-break: break-word;
    font-size: 14px;
    text-shadow: 0 1px 0 #FFF;

    a {
      color: inherit;
      text-decoration: none;
      ;
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
  line-height: 24px;
  ;
}

#search-page {
  h1 {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 12px;
  }

    h2.sidebar-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      padding: 8px 16px;
      background-color: #eeefef;

    }
}
</style>